module.exports = __webpack_public_path__ + "img/yame.021efb2c.png";